import React from "react";
import { Button as ButtonStyle } from "../../style/Button";

const Button = (props, children) => {
  return <ButtonStyle variant={props.variant} {...props} as="button" />;
};

export default Button;
